<template>
  <div class="f-ticket">
    <div class="f-ticket__qr">
      <div class="f-ticket__qr_imgs">
        <center>
          <small>{{ item.serialNumber }}</small>
        </center>
        <img
          class="hidden"
          height="40"
          src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
          alt="jn"
        >
        <div class="f-ticket__qr_qr">
          <span style="font-size: 10px;">{{ item.code_bar }}</span>
          <img
            width="110"
            :src="`https://qr.joinnus.com/qr.png?size=130&body=${item.code}`"
            alt="qr"
          >
          <p style="font-size: 10px; margin-top: 5px">{{ item.code }}</p>
        </div>
      </div>
      <div class="f-ticket__qr_vs">
        <strong>{{ item.tribuna }}</strong>
        <b>{{ item.address }}</b><br>
        <span>{{ dateStartDay }}</span>
      </div>
<!--      <div class="f-ticket__qr_tribuna">-->
<!--        <div>-->
<!--         <small>Tribuna</small>-->
<!--          <span>{{ item.mini_tribuna || item.tribuna }}</span>-->
<!--        </div>-->
<!--        <div v-if="item.puerta" class="tline">-->
<!--          <small>Pta.</small>-->
<!--          <span>{{ item.puerta }}</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="f-ticket__qr_sector">
        <span v-if="item.position">Asiento</span>
        <b v-if="item.position">{{ item.position }}</b>
        <span>&nbsp;</span>
      </div>
      <div class="f-ticket__qr_info">
        <b>*Recuerda</b>
        tu código QR es lo más importante de tu entrada Joinnus.
        Cuídalo como oro, no lo publiques y no lo compartas con nadie.
      </div>
    </div>
    <div class="f-ticket__body">
      <span class="f-ticket__body_ruc">
        {{ metadata.ruc }}
      </span>
      <small class="f-ticket__body_sure">
        Conserve su ticket. {{ metadata.poliza }}
      </small>
      <div class="f-ticket__body_content">
        <div class="f-ticket__body_head">
<!--          <div class="f-ticket__body_stadium">-->
<!--            <b>{{ metadata.stadium }}</b>-->
<!--            <small>{{ metadata.stadiumAddress }}</small>-->
<!--          </div>-->
          <div class="f-ticket__body_date">
            <div class="ft-upper">
              <b>{{ dateStartDay }}</b>
            </div>
            <div v-if="item.precio > 0">
              Precio <b>{{ metadata.currency }} {{ item.precio }}</b>
            </div>
            <div v-if="item.precio === 0 || item.precio === '0.00'">
              <b>Cortesía</b>
            </div>
          </div>
        </div>
        <div class="f-ticket__body_vs">
          <div class="f-ticket-vs">
            <div class="f-ticket-vs__head">
              <b>{{ metadata.tourney }}</b>
            </div>
            <div class="f-ticket-vs__body">
              <!-- <img height="50" :src="metadata.vs.teamPrimary.logoUrl" alt="U"> -->
              <div :class="{
                'f-ticket-vs__vs': true,
                'f-ticket-activityLogo': metadata.activityLogo,
              }">
                <img :src="metadata.activityLogo" v-if="metadata.activityLogo">
                <div>{{ item.activityTitle }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-ticket__body_tribune">
          <div style="margin-top: 5px">
            <div><b>{{ item.tribuna }}</b></div>
            <div>{{ item.username }}</div>
            <div v-if="!['null', '00000000'].includes(item.document) && item.docType !== ''">
              {{ item.docType ? item.docType : 'DNI' }}: {{ item.document }}
            </div>
            <div>Dirección: {{ item.address }}</div>
          </div>
          <div class="ft-body-sector">
            <div v-if="item.position"><span>Asiento</span> <b>{{ item.position }}</b></div>
          </div>
        </div>
        <div class="f-ticket__body_logos">
          <div>
            <img v-for="url in metadata.sponsors" :key="url" :src="url" height="21"  alt="jn">
          </div>
          <div>
            <img
              class="ft-jn"
              src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
              height="40"
              alt="jn"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="f-ticket__info">
      <div class="f-ticket__info_body">
        <div class="f-ticket__info_tribuna">
<!--          <div>-->
<!--            <div>Tribuna</div>-->
<!--            <div class="tribunaLg">-->
<!--              {{ item.mini_tribuna || item.tribuna }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-if="item.puerta">-->
<!--            <div>Pta.</div>-->
<!--            <div class="tribunaLg">-->
<!--              {{ item.puerta }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-if="item.sector">-->
<!--            <div>Sector</div>-->
<!--            <div class="tribunaLg">-->
<!--              {{ item.sector }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-if="item.fila">-->
<!--            <div>Fila</div>-->
<!--            <div class="tribunaLg">-->
<!--              {{ item.fila }}-->
<!--            </div>-->
<!--          </div>-->
          <div v-if="item.position">
            <div>Asiento</div>
            <div class="tribunaLg">
              {{ item.position }}
            </div>
          </div>
        </div>
        <div class="f-ticket__info_footer">
          <div class="f-ticket__info_vs">
            <div><strong></strong></div>
            <div class="f-ticket__info_stadium">
              {{ item.address }}
              <span>{{ dateStartDay }}</span>
            </div>
          </div>
          <div class="f-ticket__info_price">
            <div v-if="item.precio > 0">
              <small>Precio</small>
              {{ metadata.currency }} {{ item.precio }}
            </div>
            <div v-if="item.precio === 0 || item.precio === '0.00'">
              Cortesía
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="f-ticket__barcode">
      <div class="f-ticket__barcode_body">
        <div class="f-ticket__barcode_head">
          <div class="f-ticket__barcode_data">
            {{ item.username }}
            <br>
            <span v-if="!['null', '00000000'].includes(item.document) && item.docType !== ''">
              {{ item.docType ? item.docType : 'DNI' }}: {{ item.document }}
            </span>
            <span>&nbsp;</span>
          </div>
          <div class="f-ticket__barcode_price">
            <div v-if="item.precio > 0">
              <small>Precio</small>
              {{ metadata.currency }} {{ item.precio }}
            </div>
            <div v-if="item.precio === 0 || item.precio === '0.00'">
              Cortesía
            </div>
          </div>
        </div>
        <div class="f-ticket__barcode_footer">
          <div>
            {{ item.serialNumber }}
          </div>
<!--          <div style="white-space: nowrap; overflow: hidden; max-width: 130px">-->
<!--            <small>Tribuna</small>-->
<!--            {{ item.mini_tribuna || item.tribuna }}-->
<!--          </div>-->
<!--          <div v-if="item.puerta">-->
<!--            <small>Pta.</small>-->
<!--            {{ item.puerta }}-->
<!--          </div>-->
          <div>
            <img
              :src="`https://www.joinnus.com/activity/ticket/${item.code_bar || item.code}/barcode?t=2&h=20`"
              alt="barcode1"
              height="20"
              width="130"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const getFieldMeta = (key, item) => {
  const fd = item.metadata.find(el => el.key === key);
  return fd ? fd.charValue : '';
};

const generateMetadata = (item) => {
  const obj = {};

  if (!item.metadata.length) return obj;

  obj.currency = item.currency === 'PEN' ? 'S/' : '$';
  obj.dateStart = `${item.day} ${months[item.month - 1]} ${item.year} - ${item.hour}`;
  obj.stadium = item.addressRef;
  obj.stadiumAddress = item.address;

  obj.ruc = getFieldMeta('sport_ticket_ruc', item);
  obj.poliza = getFieldMeta('sport_ticket_policy', item);
  obj.tourney = getFieldMeta('sport_ticket_championship', item);
  obj.vs = getFieldMeta('sport_ticket_vs', item) && JSON.parse(getFieldMeta('sport_ticket_vs', item));
  obj.sponsors = getFieldMeta('sport_ticket_sponsors', item) && JSON.parse(getFieldMeta('sport_ticket_sponsors', item));
  obj.activityLogo = getFieldMeta('activity_logo', item);
  return obj;
};

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    metadata() {
      return generateMetadata(this.item);
    },
    dateStartDay() {
      const dateRange = getFieldMeta('date_range', this.item);
      const dateStartDay = `${this.item.day} ${months[this.item.month - 1]} ${this.item.year} - ${this.item.hour}`;
      return dateRange || dateStartDay;
    },
    dateRange() {
      const dateRange = getFieldMeta('date_range', this.item);
      return !!dateRange;
    },
  },
};

</script>

<style scoped>
.hidden {
  visibility: hidden;
}

.f-ticket-vs__head {
  text-transform: uppercase;
  font-size: 11px;
  margin-bottom: 2px;
}
.f-ticket-vs__body {
  display: flex;
  align-items: center;
  padding: 5px 2px;
  border-top: 3px solid #000;
  border-bottom: 3px solid #000;
  margin-bottom: 10px;
}
.f-ticket-vs__vs {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  padding-left: 5px;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
    text-align: center;

}
.f-ticket-activityLogo {
    display: inherit;
}
.f-ticket-vs__vs b {
  padding: 7px;
  font-size: 140%;
}

.ft-body-sector {
  display: table;
}
.ft-body-sector > div {
  width: 122px;
  display: flex;
  justify-content: space-between;
}

.f-ticket {
  font-family: sans-serif;
  margin: 3px auto;
  width: 785px;
  height: 305px;
  background: #eee;
  border-radius: 10px;
  display: flex;
  position: relative;
  zoom: 1.1;
  page-break-after: always;
}
.f-ticket:before {
  content: "";
  position: absolute;
  top: 15px;
  left: 170px;
  width: 440px;
  height: 7px;
  background: red;
  z-index: 1;
}
.f-ticket:after {
  content: "";
  position: absolute;
  top: 10px;
  left: 195px;
  width: 531px;
  height: 285px;
  background: rgba(0, 0, 0, 0.1);
}
.f-ticket * {
  box-sizing: border-box;
}
.f-ticket .ft-upper {
  text-transform: uppercase;
}
.f-ticket__qr {
  width: 185px;
  flex-shrink: 0;
  padding: 10px;
}
.f-ticket__qr_imgs {
  text-align: center;
  padding: 3px 0 7px;
}
.f-ticket__qr_qr {
  margin-top: -3px;
  position: relative;
}
.f-ticket__qr_qr p{
  margin-top: -3px;
  margin-bottom: 0;
}
.f-ticket__qr_qr span {
  font-size: 12px;
  display: block;
  width: 110px;
  position: absolute;
  bottom: 5px;
  left: 0;
  -webkit-transform-origin: left bottom;
          transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(15px);
          transform: rotate(-90deg) translateY(15px);
}
.f-ticket__qr_vs {
  margin-top: -3px;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1.2;
}
.f-ticket__qr_vs strong {
  display: block;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 10px;
}
.f-ticket__qr_tribuna {
  margin-top: 3px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  font-weight: 700;
}
.f-ticket__qr_tribuna .tline {
  width: 50%;
  padding-left: 5px;
  border-left: 1px solid #000;
}
.f-ticket__qr_tribuna > div {
  padding: 2px 0;
}
.f-ticket__qr_tribuna small {
  display: block;
  font-weight: 600;
}
.f-ticket__qr_sector {
  font-size: 11px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #000;
}
.f-ticket__qr_info {
  font-size: 7px;
  text-align: justify;
  margin-top: 5px;
}
.f-ticket__body {
  flex-shrink: 0;
  width: 440px;
  position: relative;
  z-index: 9;
}
.f-ticket__body_ruc {
  text-transform: uppercase;
  text-align: center;
  font-weight: 400;
  font-size: 10px;
  display: block;
  width: 305px;
  position: absolute;
  left: 0;
  bottom: 0;
  -webkit-transform-origin: left bottom;
          transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(25px);
          transform: rotate(-90deg) translateY(25px);
}
.f-ticket__body_sure {
  position: absolute;
  bottom: 10px;
  left: 40px;
  font-size: 9px;
  font-weight: 500;
}
.f-ticket__body_content {
  padding: 30px 20px 20px 40px;
}
.f-ticket__body_head {
  /*display: flex;*/
  justify-content: space-between;
  font-size: 13px;
}
.f-ticket__body_stadium {
  text-transform: uppercase;
}
.f-ticket__body_stadium b {
  display: block;
}
.f-ticket__body_date {
  text-align: right;
}
.f-ticket__body_vs {
  margin-top: 15px;
}
.f-ticket__body_tribune {
  font-size: 17px;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}
.f-ticket__body_tribune b {
  text-transform: uppercase;
}
.f-ticket__body_logos {
  margin-top: 8px;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 40px;
  right: 20px;
  bottom: 16px;
}
.f-ticket__body_logos .ft-jn {
  position: relative;
  right: -7px;
}
.f-ticket__info {
  flex-shrink: 0;
  position: relative;
  width: 98px;
  position: relative;
  z-index: 9;
}
.f-ticket__info_body {
  width: 305px;
  overflow: hidden;
  height: 100px;
  padding: 5px 20px;
  position: absolute;
  bottom: 0;
  -webkit-transform-origin: left bottom;
          transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(100px);
          transform: rotate(-90deg) translateY(100px);
}
.f-ticket__info_footer {
  line-height: 1.1;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.f-ticket__info_stadium {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
}
.f-ticket__info_stadium span {
  font-weight: 400;
  display: block;
    font-size: 9px;
}
.f-ticket__info_price {
  font-size: 18px;
  font-weight: 600;
}
.f-ticket__info_price small {
  font-weight: 400;
  font-size: 12px;
  display: block;
}
.f-ticket__info_tribuna {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.1;
}
.f-ticket__info_tribuna > div {
  padding: 3px 0;
}
.f-ticket__info_tribuna .tribunaLg {
  font-size: 110%;
}
.f-ticket__barcode {
  flex-shrink: 0;
  position: relative;
  width: 75px;
}
.f-ticket__barcode_body {
  width: 305px;
  overflow: hidden;
  height: 100px;
  padding: 10px 20px;
  position: absolute;
  bottom: 0;
  -webkit-transform-origin: left bottom;
          transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(95px);
          transform: rotate(-90deg) translateY(95px);
}
.f-ticket__barcode_head {
  font-size: 10px;
  display: flex;
  justify-content: space-between;
}
.f-ticket__barcode_data {
  font-weight: 600;
  text-transform: uppercase;
}
.f-ticket__barcode_price {
  font-weight: 600;
  font-size: 13px;
  line-height: 1.1;
}
.f-ticket__barcode_price small {
  font-weight: 400;
  display: block;
}
.f-ticket__barcode_footer {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.f-ticket__barcode_footer small {
  font-weight: 400;
  display: block;
}
</style>
